/**
 *  +----------------------------------------------------------------------
 *  | Copyright notion All rights reserved.
 *  +----------------------------------------------------------------------
 *  | 未经许可不能去掉notion相关版权
 *  +----------------------------------------------------------------------
 *  | Author: 诺行
 *  +----------------------------------------------------------------------
 */
import request from './../request.js'

export function accountList(params){
    return request({
        url: '/system/cardOperator/getAccountListByAgent.do?',
        method: 'post',
        data:params
    })
}

export function recordList(params){
    return request({
        url: 'card/oldcardchangerecord/list.do?',
        method: 'post',
        data:params
    })
}

export function importExcelSync(params){
    return request({
        url: 'card/oldcardchangerecord/importToNewCardSync.do?',
        method: 'post',
        data:params,
        timeout:20000,
		headers:{'Content-Type': 'multipart/form-data'}
    })
}
export function exportExcelSync(params){
    return request({
        url: 'card/oldcardchangerecord/exportExcelSync.do?',
        method: 'post',
        data:params
    })
}
export function updateForm(params){
    return request({
        url: 'card/oldcardchangerecord/updateForm.do?',
        method: 'post',
        data:params
    })
}